
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStoreBusinessExtensions"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetStoreBusinessExtensions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"business_extension"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BusinessInfo"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"store_business_extension"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StoreBusinessInfo"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"store_name"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStoreBusinessExtension"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"business_extension"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"desert_center_count"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdateStoreBusinessExtension"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"business_extension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"business_extension"}}},{"kind":"Argument","name":{"kind":"Name","value":"desert_center_count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"desert_center_count"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StoreBusinessInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StoreBusinessExtension"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"business_extension"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"desert_center_count"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BusinessInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessExtension"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"default"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":713}};
    doc.loc.source = {"body":"query GetStoreBusinessExtensions {\r\n  GetStoreBusinessExtensions {\r\n      status\r\n      business_extension{\r\n        ...BusinessInfo\r\n      }\r\n      store_business_extension{\r\n        ...StoreBusinessInfo\r\n      }\r\n      store_name\r\n  }\r\n}\r\nmutation UpdateStoreBusinessExtension (\r\n  $business_extension: String!\r\n  $desert_center_count: Int!\r\n)\r\n{\r\n    UpdateStoreBusinessExtension (\r\n      business_extension: $business_extension\r\n      desert_center_count: $desert_center_count\r\n    )\r\n    {\r\n        status\r\n    }\r\n}\r\n\r\nfragment StoreBusinessInfo on StoreBusinessExtension{\r\n  business_extension\r\n  desert_center_count\r\n}\r\n\r\nfragment BusinessInfo on BusinessExtension {\r\n   name\r\n   description\r\n   default\r\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetStoreBusinessExtensions"] = oneQuery(doc, "GetStoreBusinessExtensions");
        
        module.exports["UpdateStoreBusinessExtension"] = oneQuery(doc, "UpdateStoreBusinessExtension");
        
        module.exports["StoreBusinessInfo"] = oneQuery(doc, "StoreBusinessInfo");
        
        module.exports["BusinessInfo"] = oneQuery(doc, "BusinessInfo");
        
